!function webpackUniversalModuleDefinition(n, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"), require("@driftt/tide-icons"), require("react-router-dom"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "@driftt/tide-icons", "react-router-dom"], t);else {
    var e = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core"), require("@driftt/tide-icons"), require("react-router-dom")) : t(n.react, n["@driftt/tide-core"], n["@driftt/tide-icons"], n["react-router-dom"]);
    for (var a in e) ("object" === typeof exports ? exports : n)[a] = e[a];
  }
}(window, function (n, t, e, a) {
  return function (n) {
    var t = {};
    function __webpack_require__(e) {
      if (t[e]) return t[e].exports;
      var a = t[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return n[e].call(a.exports, a, a.exports, __webpack_require__), a.l = !0, a.exports;
    }
    return __webpack_require__.m = n, __webpack_require__.c = t, __webpack_require__.d = function (n, t, e) {
      __webpack_require__.o(n, t) || Object.defineProperty(n, t, {
        enumerable: !0,
        get: e
      });
    }, __webpack_require__.r = function (n) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (n, t) {
      if (1 & t && (n = __webpack_require__(n)), 8 & t) return n;
      if (4 & t && "object" === typeof n && n && n.__esModule) return n;
      var e = Object.create(null);
      if (__webpack_require__.r(e), Object.defineProperty(e, "default", {
        enumerable: !0,
        value: n
      }), 2 & t && "string" != typeof n) for (var a in n) __webpack_require__.d(e, a, function (t) {
        return n[t];
      }.bind(null, a));
      return e;
    }, __webpack_require__.n = function (n) {
      var t = n && n.__esModule ? function getDefault() {
        return n.default;
      } : function getModuleExports() {
        return n;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (n, t) {
      return Object.prototype.hasOwnProperty.call(n, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 7);
  }([function (t, e) {
    t.exports = n;
  }, function (n, e) {
    n.exports = t;
  }, function (n, t, e) {
    var a;
    !function () {
      "use strict";

      var e = {}.hasOwnProperty;
      function classNames() {
        for (var n = [], t = 0; t < arguments.length; t++) {
          var a = arguments[t];
          if (a) {
            var r = typeof a;
            if ("string" === r || "number" === r) n.push(a);else if (Array.isArray(a)) {
              if (a.length) {
                var o = classNames.apply(null, a);
                o && n.push(o);
              }
            } else if ("object" === r) {
              if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
                n.push(a.toString());
                continue;
              }
              for (var s in a) e.call(a, s) && a[s] && n.push(s);
            }
          }
        }
        return n.join(" ");
      }
      n.exports ? (classNames.default = classNames, n.exports = classNames) : void 0 === (a = function () {
        return classNames;
      }.apply(t, [])) || (n.exports = a);
    }();
  }, function (n, t) {
    n.exports = e;
  }, function (n, t, e) {
    "use strict";

    n.exports = function (n) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var e = function cssWithMappingToString(n, t) {
            var e = n[1] || "",
              a = n[3];
            if (!a) return e;
            if (t && "function" === typeof btoa) {
              var r = function toComment(n) {
                  return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(n)))) + " */";
                }(a),
                o = a.sources.map(function (n) {
                  return "/*# sourceURL=" + a.sourceRoot + n + " */";
                });
              return [e].concat(o).concat([r]).join("\n");
            }
            return [e].join("\n");
          }(t, n);
          return t[2] ? "@media " + t[2] + "{" + e + "}" : e;
        }).join("");
      }, t.i = function (n, e) {
        "string" === typeof n && (n = [[null, n, ""]]);
        for (var a = {}, r = 0; r < this.length; r++) {
          var o = this[r][0];
          null != o && (a[o] = !0);
        }
        for (r = 0; r < n.length; r++) {
          var s = n[r];
          null != s[0] && a[s[0]] || (e && !s[2] ? s[2] = e : e && (s[2] = "(" + s[2] + ") and (" + e + ")"), t.push(s));
        }
      }, t;
    };
  }, function (n, t, e) {
    "use strict";

    var a = {},
      r = function isOldIE() {
        var n;
        return function memorize() {
          return "undefined" === typeof n && (n = Boolean(window && document && document.all && !window.atob)), n;
        };
      }(),
      o = function getTarget() {
        var n = {};
        return function memorize(t) {
          if ("undefined" === typeof n[t]) {
            var e = document.querySelector(t);
            if (window.HTMLIFrameElement && e instanceof window.HTMLIFrameElement) try {
              e = e.contentDocument.head;
            } catch (a) {
              e = null;
            }
            n[t] = e;
          }
          return n[t];
        };
      }();
    function listToStyles(n, t) {
      for (var e = [], a = {}, r = 0; r < n.length; r++) {
        var o = n[r],
          s = t.base ? o[0] + t.base : o[0],
          i = {
            css: o[1],
            media: o[2],
            sourceMap: o[3]
          };
        a[s] ? a[s].parts.push(i) : e.push(a[s] = {
          id: s,
          parts: [i]
        });
      }
      return e;
    }
    function addStylesToDom(n, t) {
      for (var e = 0; e < n.length; e++) {
        var r = n[e],
          o = a[r.id],
          s = 0;
        if (o) {
          for (o.refs++; s < o.parts.length; s++) o.parts[s](r.parts[s]);
          for (; s < r.parts.length; s++) o.parts.push(addStyle(r.parts[s], t));
        } else {
          for (var i = []; s < r.parts.length; s++) i.push(addStyle(r.parts[s], t));
          a[r.id] = {
            id: r.id,
            refs: 1,
            parts: i
          };
        }
      }
    }
    function insertStyleElement(n) {
      var t = document.createElement("style");
      if ("undefined" === typeof n.attributes.nonce) {
        var a = e.nc;
        a && (n.attributes.nonce = a);
      }
      if (Object.keys(n.attributes).forEach(function (e) {
        t.setAttribute(e, n.attributes[e]);
      }), "function" === typeof n.insert) n.insert(t);else {
        var r = o(n.insert || "head");
        if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        r.appendChild(t);
      }
      return t;
    }
    var s = function replaceText() {
      var n = [];
      return function replace(t, e) {
        return n[t] = e, n.filter(Boolean).join("\n");
      };
    }();
    function applyToSingletonTag(n, t, e, a) {
      var r = e ? "" : a.css;
      if (n.styleSheet) n.styleSheet.cssText = s(t, r);else {
        var o = document.createTextNode(r),
          i = n.childNodes;
        i[t] && n.removeChild(i[t]), i.length ? n.insertBefore(o, i[t]) : n.appendChild(o);
      }
    }
    var i = null,
      A = 0;
    function addStyle(n, t) {
      var e, a, r;
      if (t.singleton) {
        var o = A++;
        e = i || (i = insertStyleElement(t)), a = applyToSingletonTag.bind(null, e, o, !1), r = applyToSingletonTag.bind(null, e, o, !0);
      } else e = insertStyleElement(t), a = function applyToTag(n, t, e) {
        var a = e.css,
          r = e.media,
          o = e.sourceMap;
        if (r && n.setAttribute("media", r), o && btoa && (a += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), n.styleSheet) n.styleSheet.cssText = a;else {
          for (; n.firstChild;) n.removeChild(n.firstChild);
          n.appendChild(document.createTextNode(a));
        }
      }.bind(null, e, t), r = function remove() {
        !function removeStyleElement(n) {
          if (null === n.parentNode) return !1;
          n.parentNode.removeChild(n);
        }(e);
      };
      return a(n), function updateStyle(t) {
        if (t) {
          if (t.css === n.css && t.media === n.media && t.sourceMap === n.sourceMap) return;
          a(n = t);
        } else r();
      };
    }
    n.exports = function (n, t) {
      (t = t || {}).attributes = "object" === typeof t.attributes ? t.attributes : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = r());
      var e = listToStyles(n, t);
      return addStylesToDom(e, t), function update(n) {
        for (var r = [], o = 0; o < e.length; o++) {
          var s = e[o],
            i = a[s.id];
          i && (i.refs--, r.push(i));
        }
        n && addStylesToDom(listToStyles(n, t), t);
        for (var A = 0; A < r.length; A++) {
          var u = r[A];
          if (0 === u.refs) {
            for (var c = 0; c < u.parts.length; c++) u.parts[c]();
            delete a[u.id];
          }
        }
      };
    };
  }, function (n, t) {
    n.exports = a;
  }, function (n, t, e) {
    n.exports = e(12);
  }, function (n, t, e) {
    var a = e(9);
    "string" === typeof (a = a.__esModule ? a.default : a) && (a = [[n.i, a, ""]]);
    var r = {
      insert: "head",
      singleton: !1
    };
    e(5)(a, r);
    a.locals && (n.exports = a.locals);
  }, function (n, t, e) {
    (n.exports = e(4)(!0)).push([n.i, ".container {\n  display: inline-flex;\n}\n\n.dot {\n  /*var(--color-p2)*/\n  background: rgba(36, 178, 50, 1);\n  box-shadow: 0 0 0 0 rgba(36, 178, 50, 1);\n  border-radius: 50%;\n  margin: 5px 8px 5px 5px;\n  height: 10px;\n  width: 10px;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  -webkit-animation: pulse 2s infinite;\n          animation: pulse 2s infinite;\n}\n\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(36, 178, 50, 0.7);\n  }\n\n  70% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(36, 178, 50, 0);\n  }\n\n  100% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(36, 178, 50, 0);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(36, 178, 50, 0.7);\n  }\n\n  70% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(36, 178, 50, 0);\n  }\n\n  100% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(36, 178, 50, 0);\n  }\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,2BAAmB;UAAnB,mBAAmB;EACnB,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE;IACE,8BAAsB;YAAtB,sBAAsB;IACtB,0CAA0C;EAC5C;;EAEA;IACE,2BAAmB;YAAnB,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,8BAAsB;YAAtB,sBAAsB;IACtB,wCAAwC;EAC1C;AACF;;AAfA;EACE;IACE,8BAAsB;YAAtB,sBAAsB;IACtB,0CAA0C;EAC5C;;EAEA;IACE,2BAAmB;YAAnB,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,8BAAsB;YAAtB,sBAAsB;IACtB,wCAAwC;EAC1C;AACF",
      file: "style.css",
      sourcesContent: [".container {\n  display: inline-flex;\n}\n\n.dot {\n  /*var(--color-p2)*/\n  background: rgba(36, 178, 50, 1);\n  box-shadow: 0 0 0 0 rgba(36, 178, 50, 1);\n  border-radius: 50%;\n  margin: 5px 8px 5px 5px;\n  height: 10px;\n  width: 10px;\n  transform: scale(1);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(36, 178, 50, 0.7);\n  }\n\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(36, 178, 50, 0);\n  }\n\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(36, 178, 50, 0);\n  }\n}\n"]
    }]);
  }, function (n, t, e) {
    var a = e(11);
    "string" === typeof (a = a.__esModule ? a.default : a) && (a = [[n.i, a, ""]]);
    var r = {
      insert: "head",
      singleton: !1
    };
    e(5)(a, r);
    a.locals && (n.exports = a.locals);
  }, function (n, t, e) {
    (n.exports = e(4)(!0)).push([n.i, ":root {\n  --default-subnav-transition: 0.3s ease-out;\n  --default-subnav-width: 216px;\n  --default-subnav-collapsed-width: 24px;\n}\n\n/* BASE STYLES */\n.tc-subnav-wrapper {\n  position: relative;\n  transition: width 0.3s ease-out;\n  transition: width var(--default-subnav-transition);\n  width: 216px;\n  width: var(--default-subnav-width);\n  will-change: width;\n}\n\n.tc-subnav-wrapper--collapsed {\n  width: 24px;\n  width: var(--default-subnav-collapsed-width);\n}\n\n.tc-subnav {\n  background: #fff;\n  border-right: 2px solid #f5f8fa;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex-direction: column;\n  height: 100%;\n  min-width: 216px;\n  min-width: var(--default-subnav-width);\n  padding: 0 8px 0 12px;\n  position: relative;\n  transition: all 0.3s ease-out;\n  transition: all var(--default-subnav-transition);\n  transition-property: min-width, width, -webkit-transform;\n  transition-property: min-width, width, transform;\n  transition-property: min-width, width, transform, -webkit-transform;\n  will-change: min-width, width, transform;\n  -webkit-user-select: none;\n          user-select: none;\n  vertical-align: top;\n  white-space: nowrap;\n  width: 216px;\n  width: var(--default-subnav-width);\n}\n\n.tc-subnav--overlay {\n  position: absolute;\n}\n\n.tc-subnav.tc-subnav--collapsed {\n  cursor: e-resize;\n  min-width: 24px;\n  min-width: var(--default-subnav-collapsed-width);\n  width: 24px;\n  width: var(--default-subnav-collapsed-width);\n}\n\n.tc-subnav.tc-subnav--collapsed:hover {\n  min-width: 216px;\n  min-width: var(--default-subnav-width);\n  transition-delay: 0.5s;\n  width: 216px;\n  width: var(--default-subnav-width);\n  z-index: 1000;\n}\n\n.tc-subnav.tc-subnav--collapsed:hover .tc-subnav-content,\n.tc-subnav.tc-subnav--collapsed:hover .tc-subnav-header {\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n  transition-delay: 0.5s;\n}\n\n.tc-subnav.tc-subnav--collapsed .tc-subnav-content,\n.tc-subnav.tc-subnav--collapsed .tc-subnav-header {\n  -webkit-transform: translateX(-202px);\n          transform: translateX(-202px);\n}\n\n.tc-subnav .tc-subnav-header {\n  margin: 27px 0 8px;\n  padding-left: 8px;\n}\n\n.tc-subnav .tc-subnav-content,\n.tc-subnav .tc-subnav-header {\n  color: var(--color-p1-10);\n  display: flex;\n  transition: -webkit-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;\n  transition: -webkit-transform var(--default-subnav-transition);\n  transition: transform var(--default-subnav-transition);\n  transition: transform var(--default-subnav-transition), -webkit-transform var(--default-subnav-transition);\n}\n\n.tc-subnav .tc-subnav-content {\n  box-sizing: border-box;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0;\n  overflow: auto;\n  padding: 0 0 96px;\n  width: 190px;\n}\n\n.tc-subnav .tc-subnav-content::-webkit-scrollbar {\n  width: 0px;\n  background: transparent;\n}\n/* END BASE STYLES */\n\n/* TOGGLE BUTTON */\n.tc-subnav:not(.tc-subnav--collapsed):hover + .tc-subnav-toggle-button,\n.tc-subnav--collapsed + .tc-subnav-toggle-button,\n.tc-subnav-toggle-button:hover {\n  opacity: 1;\n}\n\n.tc-subnav-toggle-button {\n  align-items: center;\n  background-color: var(--color-p1-2);\n  border-radius: 100%;\n  border: 2px solid #f5f8fa;\n  cursor: pointer;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  left: 200px;\n  opacity: 0;\n  position: absolute;\n  top: 27px;\n  transition-duration: 0.5s, 0.25s;\n  transition:\n    left 0.3s ease-out,\n    opacity 0.3s ease-out;\n  transition:\n    left var(--default-subnav-transition),\n    opacity var(--default-subnav-transition);\n  width: 24px;\n  z-index: 1;\n}\n\n.tc-subnav-toggle-button:hover {\n  background: var(--color-p1-3);\n}\n\n.tc-subnav.tc-subnav.tc-subnav--collapsed:hover + .tc-subnav-toggle-button {\n  left: 200px;\n}\n\n.tc-subnav.tc-subnav.tc-subnav--collapsed:hover + .tc-subnav-toggle-button {\n  opacity: 0;\n  transition-delay: 0.5s;\n}\n\n.tc-subnav-toggle-button svg path {\n  fill: var(--color-p1-10);\n  stroke: var(--color-p1-10);\n  stroke-width: 2px;\n}\n\n.tc-subnav-toggle-button.tc-subnav-toggle-button--collapsed {\n  left: 10px;\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n/* END TOGGLE BUTTON */\n\n/* PARENT NODE */\n.tc-subnav .tc-subnav-node-group {\n  margin-top: 24px;\n}\n\n.tc-subnav .tc-subnav-node-group + .tc-subnav-node-group {\n  margin-top: 24px;\n}\n\n.tc-subnav .tc-subnav-content > div:last-of-type {\n  margin-bottom: 24px;\n}\n\n.tc-subnav .tc-subnav-content > a:first-child {\n  margin-top: 16px;\n}\n\n.tc-subnav .tc-subnav-node-group .tc-subnav-node-group {\n  /* margin-left: 10px; */\n}\n\n.tc-subnav\n  .tc-subnav-node-group.tc-subnav-node-group--collapsed\n  > .tc-subnav-node-group-header\n  .tc-subnav-node-group-toggle\n  svg {\n  -webkit-transform: rotate(0);\n          transform: rotate(0);\n}\n\n.tc-subnav\n  .tc-subnav-node-group.tc-subnav-node-group--collapsed\n  > .tc-subnav-node-group-drawer-wrapper\n  .tc-subnav-node-group-drawer {\n  margin-top: -110%;\n}\n\n.tc-subnav .tc-subnav-node-group-header {\n  cursor: pointer;\n  font-family: var(--main-font-family--bold);\n  font-size: var(--font-size-subtle);\n  letter-spacing: 0.8px;\n  padding-left: 8px;\n}\n\n.tc-subnav .tc-subnav-node-group-toggle {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  text-transform: uppercase;\n}\n\n.tc-subnav .tc-subnav-node-group-toggle svg {\n  display: inline-block;\n  margin-top: -2px;\n  transition: -webkit-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;\n  transition: -webkit-transform var(--default-subnav-transition);\n  transition: transform var(--default-subnav-transition);\n  transition: transform var(--default-subnav-transition), -webkit-transform var(--default-subnav-transition);\n  transition-duration: 0.2s;\n}\n\n.tc-subnav .tc-subnav-node-group-toggle svg path {\n  fill: #9eabb3;\n  stroke: #9eabb3;\n}\n\n.tc-subnav .tc-subnav-node-group-toggle svg {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.tc-subnav .tc-subnav-node-group-drawer-wrapper {\n  overflow: hidden;\n}\n\n.tc-subnav .tc-subnav-node-group-drawer {\n  /* margin-left: 14px; */\n  margin-top: 0;\n  padding-top: 2px;\n  transition: margin-top 0.3s ease-out;\n  transition: margin-top var(--default-subnav-transition);\n}\n/* END PARENT NODE */\n\n/* END NODE */\n.tc-subnav .tc-subnav-content > .tc-subnav-link,\n.tc-subnav .tc-subnav-content > .tc-subnav-link + .tc-subnav-link {\n  margin-top: 0;\n}\n\n.tc-subnav .tc-subnav-link {\n  align-items: center;\n  border-radius: 2px;\n  color: #1d2225;\n  cursor: pointer;\n  display: flex;\n  font-size: var(--font-size-copy);\n  letter-spacing: -0.16px;\n  padding: 6px 8px;\n  text-decoration: none;\n  transition: all 0.3s ease-out;\n  transition: all var(--default-subnav-transition);\n}\n\n.tc-subnav .tc-subnav-link + .tc-subnav-link {\n  margin-top: 2px;\n}\n\n.tc-subnav .tc-subnav-link:hover {\n  background: #f5f8fa;\n  color: #4e5c65;\n  font-family: var(--main-font-family--bold);\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--disabled {\n  color: var(--color-p1-6);\n  cursor: default;\n  pointer-events: none;\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--disabled:hover {\n  background: inherit;\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--disabled svg path {\n  fill: #4e5c65;\n}\n\n.tc-subnav .tc-subnav-link svg {\n  margin-right: 4px;\n}\n\n.tc-subnav .tc-subnav-link svg path {\n  fill: #1d2225;\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--active,\n.tc-subnav .tc-subnav-link.tc-subnav-link--active:hover {\n  background: #f5f8fa;\n  color: #0071eb;\n  font-family: var(--main-font-family--bold);\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--active svg path {\n  fill: #0071eb;\n  stroke: #0071eb;\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--active:hover {\n  color: #0071eb;\n}\n/* END END NODE (lol) */\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,+BAAkD;EAAlD,kDAAkD;EAClD,YAAkC;EAAlC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,WAA4C;EAA5C,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,gBAAsC;EAAtC,sCAAsC;EACtC,qBAAqB;EACrB,kBAAkB;EAClB,6BAAgD;EAAhD,gDAAgD;EAChD,wDAAgD;EAAhD,gDAAgD;EAAhD,mEAAgD;EAChD,wCAAwC;EACxC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,YAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAgD;EAAhD,gDAAgD;EAChD,WAA4C;EAA5C,4CAA4C;AAC9C;;AAEA;EACE,gBAAsC;EAAtC,sCAAsC;EACtC,sBAAsB;EACtB,YAAkC;EAAlC,kCAAkC;EAClC,aAAa;AACf;;AAEA;;EAEE,gCAAwB;UAAxB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;EAEE,qCAA6B;UAA7B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,2CAAsD;EAAtD,mCAAsD;EAAtD,oEAAsD;EAAtD,8DAAsD;EAAtD,sDAAsD;EAAtD,0GAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA,oBAAoB;;AAEpB,kBAAkB;AAClB;;;EAGE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC;;yBAE0C;EAF1C;;4CAE0C;EAC1C,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kCAA0B;UAA1B,0BAA0B;AAC5B;AACA,sBAAsB;;AAEtB,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;EAKE,4BAAoB;UAApB,oBAAoB;AACtB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,kCAAkC;EAClC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2CAAsD;EAAtD,mCAAsD;EAAtD,oEAAsD;EAAtD,8DAAsD;EAAtD,sDAAsD;EAAtD,0GAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gCAAwB;UAAxB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,oCAAuD;EAAvD,uDAAuD;AACzD;AACA,oBAAoB;;AAEpB,aAAa;AACb;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,6BAAgD;EAAhD,gDAAgD;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA,uBAAuB",
      file: "style.css",
      sourcesContent: [":root {\n  --default-subnav-transition: 0.3s ease-out;\n  --default-subnav-width: 216px;\n  --default-subnav-collapsed-width: 24px;\n}\n\n/* BASE STYLES */\n.tc-subnav-wrapper {\n  position: relative;\n  transition: width var(--default-subnav-transition);\n  width: var(--default-subnav-width);\n  will-change: width;\n}\n\n.tc-subnav-wrapper--collapsed {\n  width: var(--default-subnav-collapsed-width);\n}\n\n.tc-subnav {\n  background: #fff;\n  border-right: 2px solid #f5f8fa;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex-direction: column;\n  height: 100%;\n  min-width: var(--default-subnav-width);\n  padding: 0 8px 0 12px;\n  position: relative;\n  transition: all var(--default-subnav-transition);\n  transition-property: min-width, width, transform;\n  will-change: min-width, width, transform;\n  user-select: none;\n  vertical-align: top;\n  white-space: nowrap;\n  width: var(--default-subnav-width);\n}\n\n.tc-subnav--overlay {\n  position: absolute;\n}\n\n.tc-subnav.tc-subnav--collapsed {\n  cursor: e-resize;\n  min-width: var(--default-subnav-collapsed-width);\n  width: var(--default-subnav-collapsed-width);\n}\n\n.tc-subnav.tc-subnav--collapsed:hover {\n  min-width: var(--default-subnav-width);\n  transition-delay: 0.5s;\n  width: var(--default-subnav-width);\n  z-index: 1000;\n}\n\n.tc-subnav.tc-subnav--collapsed:hover .tc-subnav-content,\n.tc-subnav.tc-subnav--collapsed:hover .tc-subnav-header {\n  transform: translateX(0);\n  transition-delay: 0.5s;\n}\n\n.tc-subnav.tc-subnav--collapsed .tc-subnav-content,\n.tc-subnav.tc-subnav--collapsed .tc-subnav-header {\n  transform: translateX(-202px);\n}\n\n.tc-subnav .tc-subnav-header {\n  margin: 27px 0 8px;\n  padding-left: 8px;\n}\n\n.tc-subnav .tc-subnav-content,\n.tc-subnav .tc-subnav-header {\n  color: var(--color-p1-10);\n  display: flex;\n  transition: transform var(--default-subnav-transition);\n}\n\n.tc-subnav .tc-subnav-content {\n  box-sizing: border-box;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0;\n  overflow: auto;\n  padding: 0 0 96px;\n  width: 190px;\n}\n\n.tc-subnav .tc-subnav-content::-webkit-scrollbar {\n  width: 0px;\n  background: transparent;\n}\n/* END BASE STYLES */\n\n/* TOGGLE BUTTON */\n.tc-subnav:not(.tc-subnav--collapsed):hover + .tc-subnav-toggle-button,\n.tc-subnav--collapsed + .tc-subnav-toggle-button,\n.tc-subnav-toggle-button:hover {\n  opacity: 1;\n}\n\n.tc-subnav-toggle-button {\n  align-items: center;\n  background-color: var(--color-p1-2);\n  border-radius: 100%;\n  border: 2px solid #f5f8fa;\n  cursor: pointer;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  left: 200px;\n  opacity: 0;\n  position: absolute;\n  top: 27px;\n  transition-duration: 0.5s, 0.25s;\n  transition:\n    left var(--default-subnav-transition),\n    opacity var(--default-subnav-transition);\n  width: 24px;\n  z-index: 1;\n}\n\n.tc-subnav-toggle-button:hover {\n  background: var(--color-p1-3);\n}\n\n.tc-subnav.tc-subnav.tc-subnav--collapsed:hover + .tc-subnav-toggle-button {\n  left: 200px;\n}\n\n.tc-subnav.tc-subnav.tc-subnav--collapsed:hover + .tc-subnav-toggle-button {\n  opacity: 0;\n  transition-delay: 0.5s;\n}\n\n.tc-subnav-toggle-button svg path {\n  fill: var(--color-p1-10);\n  stroke: var(--color-p1-10);\n  stroke-width: 2px;\n}\n\n.tc-subnav-toggle-button.tc-subnav-toggle-button--collapsed {\n  left: 10px;\n  transform: rotate(-180deg);\n}\n/* END TOGGLE BUTTON */\n\n/* PARENT NODE */\n.tc-subnav .tc-subnav-node-group {\n  margin-top: 24px;\n}\n\n.tc-subnav .tc-subnav-node-group + .tc-subnav-node-group {\n  margin-top: 24px;\n}\n\n.tc-subnav .tc-subnav-content > div:last-of-type {\n  margin-bottom: 24px;\n}\n\n.tc-subnav .tc-subnav-content > a:first-child {\n  margin-top: 16px;\n}\n\n.tc-subnav .tc-subnav-node-group .tc-subnav-node-group {\n  /* margin-left: 10px; */\n}\n\n.tc-subnav\n  .tc-subnav-node-group.tc-subnav-node-group--collapsed\n  > .tc-subnav-node-group-header\n  .tc-subnav-node-group-toggle\n  svg {\n  transform: rotate(0);\n}\n\n.tc-subnav\n  .tc-subnav-node-group.tc-subnav-node-group--collapsed\n  > .tc-subnav-node-group-drawer-wrapper\n  .tc-subnav-node-group-drawer {\n  margin-top: -110%;\n}\n\n.tc-subnav .tc-subnav-node-group-header {\n  cursor: pointer;\n  font-family: var(--main-font-family--bold);\n  font-size: var(--font-size-subtle);\n  letter-spacing: 0.8px;\n  padding-left: 8px;\n}\n\n.tc-subnav .tc-subnav-node-group-toggle {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  text-transform: uppercase;\n}\n\n.tc-subnav .tc-subnav-node-group-toggle svg {\n  display: inline-block;\n  margin-top: -2px;\n  transition: transform var(--default-subnav-transition);\n  transition-duration: 0.2s;\n}\n\n.tc-subnav .tc-subnav-node-group-toggle svg path {\n  fill: #9eabb3;\n  stroke: #9eabb3;\n}\n\n.tc-subnav .tc-subnav-node-group-toggle svg {\n  transform: rotate(90deg);\n}\n\n.tc-subnav .tc-subnav-node-group-drawer-wrapper {\n  overflow: hidden;\n}\n\n.tc-subnav .tc-subnav-node-group-drawer {\n  /* margin-left: 14px; */\n  margin-top: 0;\n  padding-top: 2px;\n  transition: margin-top var(--default-subnav-transition);\n}\n/* END PARENT NODE */\n\n/* END NODE */\n.tc-subnav .tc-subnav-content > .tc-subnav-link,\n.tc-subnav .tc-subnav-content > .tc-subnav-link + .tc-subnav-link {\n  margin-top: 0;\n}\n\n.tc-subnav .tc-subnav-link {\n  align-items: center;\n  border-radius: 2px;\n  color: #1d2225;\n  cursor: pointer;\n  display: flex;\n  font-size: var(--font-size-copy);\n  letter-spacing: -0.16px;\n  padding: 6px 8px;\n  text-decoration: none;\n  transition: all var(--default-subnav-transition);\n}\n\n.tc-subnav .tc-subnav-link + .tc-subnav-link {\n  margin-top: 2px;\n}\n\n.tc-subnav .tc-subnav-link:hover {\n  background: #f5f8fa;\n  color: #4e5c65;\n  font-family: var(--main-font-family--bold);\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--disabled {\n  color: var(--color-p1-6);\n  cursor: default;\n  pointer-events: none;\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--disabled:hover {\n  background: inherit;\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--disabled svg path {\n  fill: #4e5c65;\n}\n\n.tc-subnav .tc-subnav-link svg {\n  margin-right: 4px;\n}\n\n.tc-subnav .tc-subnav-link svg path {\n  fill: #1d2225;\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--active,\n.tc-subnav .tc-subnav-link.tc-subnav-link--active:hover {\n  background: #f5f8fa;\n  color: #0071eb;\n  font-family: var(--main-font-family--bold);\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--active svg path {\n  fill: #0071eb;\n  stroke: #0071eb;\n}\n\n.tc-subnav .tc-subnav-link.tc-subnav-link--active:hover {\n  color: #0071eb;\n}\n/* END END NODE (lol) */\n"]
    }]);
  }, function (n, t, e) {
    "use strict";

    function _typeof(n) {
      return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function _toPropertyKey(n) {
      var t = function _toPrimitive(n, t) {
        if ("object" !== _typeof(n) || null === n) return n;
        var e = n[Symbol.toPrimitive];
        if (void 0 !== e) {
          var a = e.call(n, t || "default");
          if ("object" !== _typeof(a)) return a;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(n);
      }(n, "string");
      return "symbol" === _typeof(t) ? t : String(t);
    }
    function _defineProperties(n, t) {
      for (var e = 0; e < t.length; e++) {
        var a = t[e];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, _toPropertyKey(a.key), a);
      }
    }
    function _assertThisInitialized(n) {
      if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }
    function _setPrototypeOf(n, t) {
      return (_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(n, t) {
        return n.__proto__ = t, n;
      })(n, t);
    }
    function _getPrototypeOf(n) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function _createSuper(n) {
      var t = function _isNativeReflectConstruct() {
        if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" === typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (n) {
          return !1;
        }
      }();
      return function _createSuperInternal() {
        var e,
          a = _getPrototypeOf(n);
        if (t) {
          var r = _getPrototypeOf(this).constructor;
          e = Reflect.construct(a, arguments, r);
        } else e = a.apply(this, arguments);
        return function _possibleConstructorReturn(n, t) {
          if (t && ("object" === _typeof(t) || "function" === typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return _assertThisInitialized(n);
        }(this, e);
      };
    }
    e.r(t);
    var a = e(0),
      r = e.n(a),
      o = e(2),
      s = e.n(o),
      i = e(1),
      A = e(3);
    function _objectWithoutProperties(n, t) {
      if (null == n) return {};
      var e,
        a,
        r = function _objectWithoutPropertiesLoose(n, t) {
          if (null == n) return {};
          var e,
            a,
            r = {},
            o = Object.keys(n);
          for (a = 0; a < o.length; a++) e = o[a], t.indexOf(e) >= 0 || (r[e] = n[e]);
          return r;
        }(n, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(n);
        for (a = 0; a < o.length; a++) e = o[a], t.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(n, e) && (r[e] = n[e]);
      }
      return r;
    }
    function _arrayLikeToArray(n, t) {
      (null == t || t > n.length) && (t = n.length);
      for (var e = 0, a = new Array(t); e < t; e++) a[e] = n[e];
      return a;
    }
    function _slicedToArray(n, t) {
      return function _arrayWithHoles(n) {
        if (Array.isArray(n)) return n;
      }(n) || function _iterableToArrayLimit(n, t) {
        var e = null == n ? null : "undefined" != typeof Symbol && n[Symbol.iterator] || n["@@iterator"];
        if (null != e) {
          var a,
            r,
            o,
            s,
            i = [],
            A = !0,
            u = !1;
          try {
            if (o = (e = e.call(n)).next, 0 === t) {
              if (Object(e) !== e) return;
              A = !1;
            } else for (; !(A = (a = o.call(e)).done) && (i.push(a.value), i.length !== t); A = !0);
          } catch (n) {
            u = !0, r = n;
          } finally {
            try {
              if (!A && null != e.return && (s = e.return(), Object(s) !== s)) return;
            } finally {
              if (u) throw r;
            }
          }
          return i;
        }
      }(n, t) || function _unsupportedIterableToArray(n, t) {
        if (n) {
          if ("string" === typeof n) return _arrayLikeToArray(n, t);
          var e = Object.prototype.toString.call(n).slice(8, -1);
          return "Object" === e && n.constructor && (e = n.constructor.name), "Map" === e || "Set" === e ? Array.from(n) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? _arrayLikeToArray(n, t) : void 0;
        }
      }(n, t) || function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    var u = function ParentNode(n) {
        var t = _slicedToArray(Object(a.useState)(n.expanded), 2),
          e = t[0],
          o = t[1],
          u = n.label,
          c = n.className,
          l = n.onClick,
          b = v(n.nodes);
        return r.a.createElement(i.Div, {
          className: s()("tc-subnav-node-group", {
            "tc-subnav-node-group--collapsed": !e
          }, c)
        }, r.a.createElement(i.Div, {
          className: "tc-subnav-node-group-header",
          onClick: function toggleClick() {
            l && l(), o(!e);
          }
        }, r.a.createElement(i.Div, {
          className: "tc-subnav-node-group-toggle"
        }, u, r.a.createElement(A.Icon, {
          name: "arrow-1-right",
          width: "8",
          height: "8"
        }))), r.a.createElement(i.Div, {
          className: "tc-subnav-node-group-drawer-wrapper"
        }, r.a.createElement(i.Div, {
          className: "tc-subnav-node-group-drawer"
        }, b)));
      },
      c = e(6),
      l = (e(8), function RealTimeDot() {
        return r.a.createElement("div", {
          className: "container"
        }, r.a.createElement("div", {
          className: "dot"
        }));
      }),
      b = ["label", "path", "icon", "className", "onClick", "exact", "external", "disabled", "showRealtimeDot"],
      p = function EndNode(n) {
        var t = n.label,
          e = n.path,
          a = n.icon,
          o = (n.className, n.onClick),
          u = n.exact,
          p = void 0 === u || u,
          d = n.external,
          v = void 0 === d ? "string" === typeof e && e.match(/^http/) : d,
          f = n.disabled,
          g = n.showRealtimeDot,
          E = _objectWithoutProperties(n, b),
          C = {
            exact: p,
            to: e,
            activeClassName: "tc-subnav-link--active"
          },
          m = {
            href: e
          },
          B = v ? i.A : c.NavLink;
        return r.a.createElement(B, Object.assign({
          className: s()("tc-subnav-link", {
            "tc-subnav-link--disabled": f
          }, s.a),
          onClick: function onClick() {
            return o && o();
          }
        }, v ? m : C, E), g && r.a.createElement(l, null), a && r.a.createElement(A.Icon, {
          name: a,
          height: "12",
          width: "12"
        }), t);
      },
      d = ["hide"],
      v = function getChildNodes(n) {
        return n.map(function (n) {
          var t = n.hide,
            e = _objectWithoutProperties(n, d),
            a = e.nodes ? u : p;
          return t ? null : r.a.createElement(a, Object.assign({
            key: e.label
          }, e));
        });
      },
      f = (e(10), function (n) {
        !function _inherits(n, t) {
          if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          n.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: n,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(n, "prototype", {
            writable: !1
          }), t && _setPrototypeOf(n, t);
        }(Subnav, a["Component"]);
        var t = _createSuper(Subnav);
        function Subnav(n) {
          var e;
          return function _classCallCheck(n, t) {
            if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, Subnav), (e = t.call(this, n)).state = {
            open: n.open
          }, e.onToggle = e.onToggle.bind(_assertThisInitialized(e)), e;
        }
        return function _createClass(n, t, e) {
          return t && _defineProperties(n.prototype, t), e && _defineProperties(n, e), Object.defineProperty(n, "prototype", {
            writable: !1
          }), n;
        }(Subnav, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            var n = document.getElementsByClassName("tc-subnav-link--active")[0];
            n && n.scrollIntoView({
              behavior: "instant"
            });
          }
        }, {
          key: "onToggle",
          value: function onToggle() {
            var onToggle = this.props.onToggle;
            onToggle && onToggle(), this.setState({
              open: !this.state.open
            });
          }
        }, {
          key: "render",
          value: function render() {
            var n = this.state.open,
              t = this.props,
              e = t.className,
              a = t.mode,
              o = "tc-subnav--".concat(a),
              u = v(this.props.nodes);
            return r.a.createElement(i.Div, {
              className: s()("tc-subnav-wrapper", {
                "tc-subnav-wrapper--collapsed": !n
              })
            }, r.a.createElement(i.Div, {
              className: s()("tc-subnav", {
                "tc-subnav--collapsed": !n
              }, o, e)
            }, r.a.createElement(i.H3, {
              className: "tc-subnav-header"
            }, this.props.title), r.a.createElement(i.Div, {
              className: "tc-subnav-content"
            }, u)), r.a.createElement(i.Div, {
              className: s()("tc-subnav-toggle-button", {
                "tc-subnav-toggle-button--collapsed": !n
              }),
              onClick: this.onToggle
            }, r.a.createElement(A.Icon, {
              name: "arrow-1-left",
              width: "8",
              height: "8"
            })));
          }
        }]), Subnav;
      }());
    f.defaultProps = {
      mode: "slide",
      open: !0
    };
    var g = f;
    e.d(t, "Subnav", function () {
      return g;
    });
  }]);
});